import React from "react";
import { InventoryInFormModal } from "../InventoryInFormModal";

export function DefectiveReplacementFromVendorModal({ open, onOpenChange, onSuccess }) {
  return (
    <InventoryInFormModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      sourceType="Defective_Replacement_From_Vendor"
      labelKey="inventory.defectiveReplacementFromVendor"
    />
  );
}
